<template>
  <ul :class="b('', { variant })">
    <li
      v-if="!!myNikoPortal"
      :class="b('item')"
    >
      <a
        :href="myNikoPortal.url"
        :target="myNikoPortal?.target ?? undefined"
        :title="myNikoPortal?.title ?? undefined"
        :class="b('link')"
      >
        {{ myNikoPortal?.label }}
      </a>
    </li>
  </ul>
</template>

<script lang="ts">
  import { defineComponent } from 'vue';
  import useSessionStore from '@/stores/session';
  import { Link } from '@/types/link';

  type Setup = {
    sessionStore: ReturnType<typeof useSessionStore>;
  };
  // type Data = {};

  /**
   * Renders the user navigation menu.
   */
  export default defineComponent({
    name: 'c-user-navigation-menu',
    // components: {},

    props: {
      /**
       * Define a display variant.
       */
      variant: {
        type: String,
        default: 'desktop',
        validator: (value: string) => ['desktop', 'mobile'].includes(value),
      },
    },
    // emits: [],

    setup(): Setup {
      return {
        sessionStore: useSessionStore(),
      };
    },
    // data(): Data {
    //   return {
    //   };
    // },

    computed: {
      myNikoPortal(): Link | null {
        return this.sessionStore.myNikoPortal;
      },
    },
    // watch: {},

    // beforeCreate() {},
    // created() {},
    // beforeMount() {},
    // mounted() {},
    // beforeUpdate() {},
    // updated() {},
    // activated() {},
    // deactivated() {},
    // beforeUnmount() {},
    // unmounted() {},

    // methods: {},
    // render() {},
  });
</script>

<style lang="scss">
  @use '@/setup/scss/mixins';
  @use '@/setup/scss/variables';

  .c-user-navigation-menu {
    $this: &;

    display: flex;
    flex-direction: column;
    width: 100%;

    &--variant-desktop {
      #{$this}__link {
        display: flex;
        width: 100%;
        padding: 0.75rem 1.5rem;
        text-decoration: none;
        color: var(--theme-font-color--text);

        &:hover {
          background: var(--theme-color-grayscale--800);
          color: var(--theme-color-grayscale--400);
        }
      }
    }

    &--variant-mobile {
      #{$this}__link {
        color: var(--theme-color-grayscale--1000);
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        padding: 1.5rem;
        text-decoration: none;
        border-bottom: 1px solid var(--theme-color-grayscale--300);
      }
    }
  }
</style>
